<template>
  <div
    v-if="visible"
    class="kk-name-range-area"
    :style="{
      gridArea: `${refinedRange[1] + 2} / ${refinedRange[0] + 2} / ${refinedRange[3] + 3} / ${refinedRange[2] + 3}`,
    }"
  >
    <canvas ref="canvas" class="kk-name-range-area-canvas" :style="{ ...canvasStyle }"></canvas>

    <!-- Centered Title -->
    <div
      :style="{
        ...titleStyle,
      }"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
import { ProcessTypes } from "../../utils/icons";
import { DefaultWidths } from "../process-design/corner/CornerConstants";
import DesignerMixin from "../process-design/DesignerMixin";

export default {
  name: "NameRangeArea",
  mixins: [DesignerMixin],
  props: ["index", "options", "getPxFromRowIndex", "getPxFromColumnIndex", "item", "visible"],
  data() {
    return {
      dragging: false,
    };
  },

  computed: {
    title() {
      return this.$store.getters["table/getLocalNameRangeByDefault"](this.item?.title) || "";
    },
    refinedRange() {
      const maxHScroll = this.$store.state.cells.hScroll.end - this.$store.state.cells.hScroll.index;
      const maxVScroll = this.$store.state.cells.vScroll.end - this.$store.state.cells.vScroll.index;
      const range = this.item.range;
      return [
        Math.max(0, Math.min(maxHScroll, range[0] - this.$store.state.cells.hScroll.index)),
        Math.max(0, Math.min(maxVScroll, range[1] - this.$store.state.cells.vScroll.index)),
        Math.min(maxHScroll, Math.max(0, range[2] - this.$store.state.cells.hScroll.index)),
        Math.min(maxVScroll, Math.max(0, range[3] - this.$store.state.cells.vScroll.index)),
      ];
    },

    canvasStyle() {
      return {
        borderRadius: `${this.options.borderRadius ?? 0}px`,
        border: "1px solid #1d6fa3",
      };
    },
    defaultColumnWidth() {
      return this.current.type === ProcessTypes.Grid
        ? DefaultWidths.Grid
        : this.current.type === ProcessTypes.Normal
        ? DefaultWidths.Default
        : DefaultWidths.Default / 2;
    },
    titleStyle() {
      if (!this.item?.range || !this.getPxFromColumnIndex || !this.getPxFromRowIndex) return {};

      const [refinedStartCol, , refinedEndCol] = this.refinedRange;

      const canvasWidth = Math.ceil(
        this.getPxFromColumnIndex(refinedEndCol) - this.getPxFromColumnIndex(refinedStartCol) + this.defaultColumnWidth
      );

      const isNarrow = canvasWidth < 180;
      const isVeryNarrow = canvasWidth < 90;
      return {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: `translate(-50%, -50%)${isNarrow ? " rotate(90deg)" : ""}`,
        pointerEvents: "none",
        whiteSpace: "nowrap",
        fontWeight: "bold",
        fontSize: isVeryNarrow ? "18px" : isNarrow ? "24px" : "32px",
        color: "#55b2f987",
        textAlign: "center",
      };
    },
  },
  mounted() {
    this.drawCanvas();
    document.addEventListener("mouseup", this.mouseUp);
  },
  beforeUnmount() {
    document.removeEventListener("mouseup", this.mouseUp);
  },
  methods: {
    drawCanvas() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      canvas.width = canvas.clientWidth;
      canvas.height = canvas.clientHeight;
      ctx.fillStyle = `rgba(13, 102, 154, 0)`;
      ctx.fillRect(0, 0, canvas.clientWidth, canvas.clientHeight);
    },
  },
};
</script>

<style scoped>
.kk-name-range-area {
  border-radius: 0.25rem;
  z-index: 13;
  pointer-events: none;
  position: relative;
}

.kk-name-range-area-canvas {
  width: 100%;
  height: 100%;
}
</style>
